
import { useRecordContext } from "react-admin";
import MessageOutlinedIcon from '@mui/icons-material/MessageOutlined';
import { Button } from "@mui/material";
import { stringify } from "query-string";
import { Link } from 'react-router-dom';

export const ShowMessagesForReportButton = (props: any) => {

    const record = useRecordContext(props);


    if (record) {
        const users = [record.reporter, record.about];
        return (
            <Button component={Link}
                target="_blank"
                to={{
                    pathname: '/message',
                    search: `${stringify({ filter: JSON.stringify({ users }) })}`,
                }}>
                <MessageOutlinedIcon />
            </Button>
        )
    } else {
        return (<></>)
    }


}